import { render, staticRenderFns } from "./EmployeeColumnCustomizationEditor.vue?vue&type=template&id=40397f2f&scoped=true&"
import script from "./EmployeeColumnCustomizationEditor.vue?vue&type=script&lang=js&"
export * from "./EmployeeColumnCustomizationEditor.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeColumnCustomizationEditor.vue?vue&type=style&index=0&id=40397f2f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40397f2f",
  null
  
)

export default component.exports